export const currencies = [
  { value: 1, label: "USD" },
  { value: 2, label: "EUR" },
  { value: 5, label: "RSD" },
];
